module.exports = __webpack_public_path__ + "img/DE02694.132f9bdc.png";